module.exports = __webpack_public_path__ + "img/73.41f5f382.webp";